/* ECADRA Reviews — behaviour for every review block on the page (filters, show more, photo lightbox, carousel,
   and on mobile: swipe rail + full-screen reviews sheet). One delegated listener; safe to include from several
   sections (runs once). No dependencies. */
(function () {
  if (window.__ecadraReviews) return;
  window.__ecadraReviews = true;

  var RAIL_CARDS = 6;
  var mq = window.matchMedia('(max-width: 749px)');

  function applyFilter(root, f) {
    var shown = 0;
    root.querySelectorAll('.erv__list .erv__card').forEach(function (c) {
      var ok = f === 'all' || (f === 'photos' ? c.dataset.photos === '1' : c.dataset.rating === f);
      c.classList.toggle('is-filtered', !ok);
      if (ok) shown++;
    });
    if (f !== 'all') root.setAttribute('data-expanded', '');
    var none = root.querySelector('.erv__none');
    if (none) none.hidden = shown > 0;
    root.querySelectorAll('.erv__chip').forEach(function (b) {
      var on = b.dataset.ervFilter === f;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  var box;
  function lightbox(src, label) {
    if (!box) {
      box = document.createElement('dialog');
      box.className = 'erv-lightbox';
      box.innerHTML = '<form method="dialog"><button class="erv-lightbox__close" aria-label="Close">✕</button></form><img alt="">';
      box.addEventListener('click', function (e) { if (e.target === box) box.close(); });
      document.body.appendChild(box);
    }
    var img = box.querySelector('img');
    img.src = src;
    img.alt = label || '';
    if (typeof box.showModal === 'function') box.showModal();
    else window.open(src, '_blank', 'noopener');
  }

  /* ---------- mobile: rail + sheet (product page section only) ---------- */

  var openSheet = null; // { root, sheet, opener }

  function buildRail(root) {
    var rail = root.querySelector('[data-erv-rail]');
    if (!rail || rail.childElementCount) return;
    var cards = [].slice.call(root.querySelectorAll('.erv__list .erv__card'), 0, RAIL_CARDS);
    cards.forEach(function (c) {
      var k = c.cloneNode(true); // clones exist only in the live DOM, never in the HTML Google reads
      k.classList.remove('is-extra', 'is-filtered', 'is-target');
      k.classList.add('erv__card--compact');
      k.setAttribute('data-erv-jump', c.getAttribute('data-rid') || '');
      k.setAttribute('role', 'button');
      k.setAttribute('tabindex', '0');
      rail.appendChild(k);
    });
    var tpl = root.querySelector('[data-erv-all-label]');
    var all = document.createElement('button');
    all.type = 'button';
    all.className = 'erv__rail-all';
    all.setAttribute('data-erv-open', '');
    var arrow = document.createElement('span');
    arrow.textContent = document.documentElement.dir === 'rtl' ? '←' : '→';
    all.appendChild(document.createTextNode(tpl ? tpl.content.textContent.trim() : 'See all'));
    all.appendChild(arrow);
    rail.appendChild(all);
  }

  function setupMobile() {
    document.querySelectorAll('[data-erv]').forEach(function (root) {
      var sheet = root.querySelector('[data-erv-sheet]');
      var rail = root.querySelector('[data-erv-rail]');
      if (!sheet || !rail) return;
      if (mq.matches) {
        buildRail(root);
        root.classList.add('is-m');
        rail.hidden = false;
        sheet.setAttribute('role', 'dialog');
        sheet.setAttribute('aria-modal', 'true');
      } else {
        closeSheet(false);
        root.classList.remove('is-m');
        rail.hidden = true;
        sheet.removeAttribute('role');
        sheet.removeAttribute('aria-modal');
      }
    });
  }

  function open(root, jumpTo, opener) {
    var sheet = root.querySelector('[data-erv-sheet]');
    if (!sheet || !root.classList.contains('is-m')) return;
    sheet.classList.add('is-open');
    document.body.classList.add('erv-lock');
    openSheet = { root: root, sheet: sheet, opener: opener };
    try { history.pushState({ ervSheet: true }, ''); } catch (e) {}
    sheet.scrollTop = 0;
    var target = jumpTo && sheet.querySelector('.erv__list [data-rid="' + (window.CSS && CSS.escape ? CSS.escape(jumpTo) : jumpTo) + '"]');
    sheet.querySelectorAll('.is-target').forEach(function (c) { c.classList.remove('is-target'); });
    if (target) {
      applyFilter(root, 'all');
      root.setAttribute('data-expanded', '');
      target.classList.add('is-target');
      // scroll the sheet itself (not the page) so the tapped review sits under the sticky header + filters
      var head = sheet.querySelector('.erv__sheet-head');
      var filters = sheet.querySelector('.erv__filters');
      var offset = (head ? head.offsetHeight : 0) + (filters ? filters.offsetHeight : 0) + 12;
      sheet.scrollTop = Math.max(0, target.getBoundingClientRect().top - sheet.getBoundingClientRect().top + sheet.scrollTop - offset);
    }
    var close = sheet.querySelector('[data-erv-close]');
    if (close) close.focus({ preventScroll: true });
  }

  function closeSheet(viaHistory) {
    if (!openSheet) return;
    var s = openSheet;
    openSheet = null;
    s.sheet.classList.remove('is-open');
    document.body.classList.remove('erv-lock');
    if (s.opener && s.opener.focus) s.opener.focus({ preventScroll: true });
    if (viaHistory !== true && history.state && history.state.ervSheet) {
      try { history.back(); } catch (e) {}
    }
  }

  window.addEventListener('popstate', function () { closeSheet(true); }); // phone "back" closes the sheet
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openSheet) closeSheet();
    if ((e.key === 'Enter' || e.key === ' ') && e.target.matches && e.target.matches('[data-erv-jump]')) {
      e.preventDefault();
      open(e.target.closest('[data-erv]'), e.target.getAttribute('data-erv-jump'), e.target);
    }
  });
  if (mq.addEventListener) mq.addEventListener('change', setupMobile); else mq.addListener(setupMobile);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupMobile); else setupMobile();

  /* ---------- write a review (dialog + Turnstile + client-side photo resize) ---------- */

  var MAX_PHOTOS = 3, MAX_SIDE = 1600;
  var ts = { loading: null, widget: null };

  function loadTurnstile() {
    if (window.turnstile) return Promise.resolve(window.turnstile);
    if (ts.loading) return ts.loading;
    ts.loading = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      s.async = true;
      s.onload = function () { resolve(window.turnstile); };
      s.onerror = function () { ts.loading = null; reject(new Error('turnstile')); };
      document.head.appendChild(s);
    });
    return ts.loading;
  }

  /** re-encode to JPEG ≤ 1600px: smaller upload + drops any hidden metadata before it leaves the phone */
  function resize(file) {
    return new Promise(function (resolve) {
      var url = URL.createObjectURL(file), img = new Image();
      img.onload = function () {
        var k = Math.min(1, MAX_SIDE / Math.max(img.naturalWidth, img.naturalHeight));
        var c = document.createElement('canvas');
        c.width = Math.round(img.naturalWidth * k); c.height = Math.round(img.naturalHeight * k);
        c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
        URL.revokeObjectURL(url);
        c.toBlob(function (b) { resolve(b); }, 'image/jpeg', 0.85);
      };
      img.onerror = function () { URL.revokeObjectURL(url); resolve(null); };
      img.src = url;
    });
  }

  function formOf(root) { return root.querySelector('[data-erv-form-dialog]'); }

  function openForm(root) {
    var dlg = formOf(root);
    if (!dlg) return;
    dlg.querySelector('[data-erv-form]').hidden = false;
    dlg.querySelector('[data-erv-form-done]').hidden = true;
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
    var box = dlg.querySelector('[data-erv-turnstile]');
    loadTurnstile().then(function (t) {
      if (ts.widget !== null) { try { t.reset(ts.widget); } catch (e) {} return; }
      ts.widget = t.render(box, { sitekey: dlg.dataset.sitekey, language: dlg.dataset.lang === 'ar' ? 'ar' : 'en', theme: 'light', size: 'flexible' });
    }).catch(function () { dlg.querySelector('[data-erv-form-error]').textContent = dlg.dataset.msgFailed; });
  }

  function setupForms() {
    document.querySelectorAll('[data-erv-form-dialog]').forEach(function (dlg) {
      if (dlg.dataset.ready) return;
      dlg.dataset.ready = '1';
      var form = dlg.querySelector('[data-erv-form]');
      var err = dlg.querySelector('[data-erv-form-error]');
      var btn = dlg.querySelector('[data-erv-submit]');
      var input = dlg.querySelector('[data-erv-photos]');
      var previews = dlg.querySelector('[data-erv-previews]');
      var photos = [];

      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
      form.addEventListener('input', function () { err.textContent = ''; });

      input.addEventListener('change', function () {
        var files = [].slice.call(input.files, 0, MAX_PHOTOS);
        previews.replaceChildren();
        Promise.all(files.map(resize)).then(function (blobs) {
          photos = blobs.filter(Boolean);
          photos.forEach(function (b) {
            var im = document.createElement('img');
            im.alt = ''; im.src = URL.createObjectURL(b);
            previews.appendChild(im);
          });
        });
      });

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        err.textContent = '';
        if (!form.querySelector('input[name="rating"]:checked')) { err.textContent = dlg.dataset.msgRating; return; }
        if (form.body.value.trim().length < 3) { err.textContent = dlg.dataset.msgBody; form.body.focus(); return; }
        if (form.name.value.trim().length < 2) { err.textContent = dlg.dataset.msgName; form.name.focus(); return; }
        var fd = new FormData(form);
        if (!fd.get('cf-turnstile-response')) { err.textContent = dlg.dataset.msgHuman; return; }
        fd.delete('photos');
        photos.forEach(function (b, i) { fd.append('photos', b, 'photo-' + (i + 1) + '.jpg'); });
        var label = btn.textContent;
        btn.disabled = true; btn.textContent = dlg.dataset.msgSending;
        fetch('/apps/reviews/submit', { method: 'POST', body: fd, credentials: 'same-origin' })
          .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok || !j.ok) throw new Error(j.error || dlg.dataset.msgFailed); return j; }); })
          .then(function () {
            form.reset(); photos = []; previews.replaceChildren();
            form.hidden = true;
            dlg.querySelector('[data-erv-form-done]').hidden = false;
          })
          .catch(function (e2) { err.textContent = e2.message; })
          .then(function () {
            btn.disabled = false; btn.textContent = label;
            if (window.turnstile && ts.widget !== null) { try { window.turnstile.reset(ts.widget); } catch (e3) {} } // tokens are single-use
          });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupForms); else setupForms();

  /* ---------- clicks ---------- */

  document.addEventListener('click', function (e) {
    var root = e.target.closest('[data-erv]');
    if (!root) return;
    var t;
    if ((t = e.target.closest('[data-erv-photo]'))) return lightbox(t.dataset.ervPhoto, t.getAttribute('aria-label'));
    if (e.target.closest('[data-erv-write]')) return openForm(root);
    if ((t = e.target.closest('[data-erv-form-close]'))) { var d = t.closest('dialog'); if (d) d.close(); return; }
    if (e.target.closest('[data-erv-close]')) return closeSheet();
    if ((t = e.target.closest('[data-erv-open]'))) return open(root, null, t);
    if ((t = e.target.closest('[data-erv-jump]'))) return open(root, t.getAttribute('data-erv-jump'), t);
    if ((t = e.target.closest('[data-erv-filter]'))) {
      applyFilter(root, t.dataset.ervFilter);
      if (openSheet) openSheet.sheet.scrollTop = 0;
      return;
    }
    if (e.target.closest('[data-erv-more]')) return root.setAttribute('data-expanded', '');
    if ((t = e.target.closest('[data-erv-scroll]'))) {
      var track = root.querySelector('[data-erv-track]');
      if (!track) return;
      var rtl = getComputedStyle(track).direction === 'rtl';
      var dir = Number(t.dataset.ervScroll) * (rtl ? -1 : 1);
      track.scrollBy({ left: dir * track.clientWidth * 0.9, behavior: 'smooth' });
    }
  });
})();
